import { render, staticRenderFns } from "./DatasetDetail.vue?vue&type=template&id=f488cc14&scoped=true"
import script from "./DatasetDetail.vue?vue&type=script&lang=js"
export * from "./DatasetDetail.vue?vue&type=script&lang=js"
import style0 from "./DatasetDetail.vue?vue&type=style&index=0&id=f488cc14&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f488cc14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f488cc14')) {
      api.createRecord('f488cc14', component.options)
    } else {
      api.reload('f488cc14', component.options)
    }
    module.hot.accept("./DatasetDetail.vue?vue&type=template&id=f488cc14&scoped=true", function () {
      api.rerender('f488cc14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/common/DatasetDetail.vue"
export default component.exports